// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v1/sandbox.proto (package infinigence.infini.agentplatform.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Param } from "./param_pb.js";
import { file_agentplatform_v1_param } from "./param_pb.js";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v1/sandbox.proto.
 */
export const file_agentplatform_v1_sandbox: GenFile = /*@__PURE__*/
  fileDesc("Ch5hZ2VudHBsYXRmb3JtL3YxL3NhbmRib3gucHJvdG8SI2luZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxIsUMCgdTYW5kYm94EjIKAmlkGAEgASgJQia6RyM6EhIQInNhbmRib3gtYWJjMTIzIpICDOi1hOa6kOe8luWPtxIyCgRuYW1lGAMgASgJQiS6RyE6EBIOIuaIkeeahOaymeeusSKSAgzmspnnrrHlkI3np7ASSAoLZGVzY3JpcHRpb24YBCABKAlCM7pHMDofEh0i55So5LqO5Luj56CB5omn6KGM55qE5rKZ566xIpICDOaymeeuseaPj+i/sBJACgl0ZW5hbnRfaWQYBSABKAlCIrpHHzoREg8idGVuYW50LWFiYzEyMyKSAgnnp5/miLcgSURSCXRlbmFudF9pZBI6Cgd1c2VyX2lkGAYgASgJQiC6Rx06DxINInVzZXItYWJjMTIzIpICCeeUqOaItyBJRFIHdXNlcl9pZBJJCghjbGFzc19pZBgHIAEoCUItukcqOhASDiJjbGFzcy1hYmMxMjMikgIV5omA5bGe55qE5rKZ566x57G7IElEUghjbGFzc19pZBKcAQoMY2xhc3NfcGFyYW1zGAggAygLMj0uaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuU2FuZGJveC5DbGFzc1BhcmFtc0VudHJ5Qjm6RzaSAjPkvb/nlKjmspnnrrHnsbvliJvlu7rmspnnrrHml7bkvKDlhaXnmoTlj4LmlbDliJfooahSDGNsYXNzX3BhcmFtcxIsCgR0eXBlGAogASgJQh66Rxs6ChIIImRvY2tlciKSAgzmspnnrrHnsbvlnosSNgoIcHJvdmlkZXIYCyABKAlCJLpHIToHEgUiZTJiIpICFeaymeeuseacjeWKoeaPkOS+m+iAhRJQCg9zYW5kYm94X3NwZWNfaWQYDCABKAlCJrpHIzoPEg0ic3BlYy1hYmMxMjMikgIP5rKZ566x6KeE5qC8IElEUg9zYW5kYm94X3NwZWNfaWQSXQoWc2FuZGJveF9lbnZpcm9ubWVudF9pZBgNIAEoCUIlukciOg4SDCJlbnYtYWJjMTIzIpICD+aymeeuseeOr+WigyBJRFIWc2FuZGJveF9lbnZpcm9ubWVudF9pZBJcCgNlbnYYDiADKAsyNS5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5TYW5kYm94LkVudkVudHJ5Qhi6RxWSAhLmspnnrrHnjq/looPlj5jph48SzQEKFXJlcXVpcmVfdG9vbF9hcHByb3ZhbBgTIAEoCEKWAbpHkgE6BxIFZmFsc2WSAoUB5rKZ566x5bel5YW36LCD55So5piv5ZCm6ZyA6KaB5a6h5om544CCdHJ1ZTog5omA5pyJ5bel5YW36LCD55So6ZyA5a6h5om556Gu6K6k77ybZmFsc2UvdW5zZXQ6IOaJgOacieiwg+eUqOWFjeWuoeaJue+8iOWQkeWQjuWFvOWuue+8iVIVcmVxdWlyZV90b29sX2FwcHJvdmFsElMKDG1vdW50X3BvaW50cxgUIAMoCzIvLmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLk1vdW50UG9pbnRSDG1vdW50X3BvaW50cxJcCgpjcmVhdGVkX2F0GBAgASgDQjy6Rzk6DBIKMTcwMDAwMDAwMJICIOWIm+W7uuaXtumXtO+8iFVuaXgg5pe26Ze05oiz77yJmgIFaW50NjRSCmNyZWF0ZWRfYXQSXAoKdXBkYXRlZF9hdBgRIAEoA0I8ukc5OgwSCjE3MDAwMDAwMDCSAiDmm7TmlrDml7bpl7TvvIhVbml4IOaXtumXtOaIs++8iZoCBWludDY0Ugp1cGRhdGVkX2F0ElwKCmRlbGV0ZWRfYXQYEiABKANCPLpHOToMEgoxNzAwMDAwMDAwkgIg5Yig6Zmk5pe26Ze077yIVW5peCDml7bpl7TmiLPvvImaAgVpbnQ2NFIKZGVsZXRlZF9hdBoyChBDbGFzc1BhcmFtc0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAEaKgoIRW52RW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4AToMukcJkgIG5rKZ566xIu4CCgpNb3VudFBvaW50EgoKAmlkGAEgASgJEkEKBHR5cGUYAiABKA4yMy5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5Nb3VudFBvaW50VHlwZRIcCglzZWNyZXRfaWQYAyABKAlSCXNlY3JldF9pZBIOCgZzb3VyY2UYBCABKAkSGAoHc3ViX2RpchgFIAEoCVIHc3ViX2RpchIeCgptb3VudF9wYXRoGAYgASgJUgptb3VudF9wYXRoEhwKCXJlYWRfb25seRgHIAEoCFIJcmVhZF9vbmx5Ek0KB29wdGlvbnMYCCADKAsyPC5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5Nb3VudFBvaW50Lk9wdGlvbnNFbnRyeRIMCgRub3RlGAkgASgJGi4KDE9wdGlvbnNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBIpIBCgtTYW5kYm94VG9vbBIuCgRuYW1lGAEgASgJQiC6Rx06DBIKInJ1bl9jb2RlIpICDOW3peWFt+WQjeensBI/CgtkZXNjcmlwdGlvbhgCIAEoCUIqukcnOhYSFCLmiafooYzku6PnoIHlt6XlhbcikgIM5bel5YW35o+P6L+wOhK6Rw+SAgzmspnnrrHlt6XlhbcinQYKDFNhbmRib3hDbGFzcxIwCgJpZBgBIAEoCUIkukchOhASDiJjbGFzcy1hYmMxMjMikgIM6LWE5rqQ57yW5Y+3EjgKBG5hbWUYAyABKAlCKrpHJzoTEhEi5oiR55qE5rKZ566x57G7IpICD+aymeeuseexu+WQjeensBJOCgtkZXNjcmlwdGlvbhgEIAEoCUI5ukc2OiISICLnlKjkuo7ku6PnoIHmiafooYznmoTmspnnrrHnsbsikgIP5rKZ566x57G75o+P6L+wEkAKCXRlbmFudF9pZBgFIAEoCUIiukcfOhESDyJ0ZW5hbnQtYWJjMTIzIpICCeenn+aItyBJRFIJdGVuYW50X2lkEjoKB3VzZXJfaWQYBiABKAlCILpHHToPEg0idXNlci1hYmMxMjMikgIJ55So5oi3IElEUgd1c2VyX2lkElUKCHRlbXBsYXRlGAogASgLMiwuaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuU2FuZGJveEIVukcSkgIP5rKZ566xIFRlbXBsYXRlElEKBnBhcmFtcxgLIAMoCzIqLmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLlBhcmFtQhW6RxKSAg/mspnnrrHnsbvlj4LmlbASXAoKY3JlYXRlZF9hdBgMIAEoA0I8ukc5OgwSCjE3MDAwMDAwMDCSAiDliJvlu7rml7bpl7TvvIhVbml4IOaXtumXtOaIs++8iZoCBWludDY0UgpjcmVhdGVkX2F0ElwKCnVwZGF0ZWRfYXQYDSABKANCPLpHOToMEgoxNzAwMDAwMDAwkgIg5pu05paw5pe26Ze077yIVW5peCDml7bpl7TmiLPvvImaAgVpbnQ2NFIKdXBkYXRlZF9hdBJcCgpkZWxldGVkX2F0GA4gASgDQjy6Rzk6DBIKMTcwMDAwMDAwMJICIOWIoOmZpOaXtumXtO+8iFVuaXgg5pe26Ze05oiz77yJmgIFaW50NjRSCmRlbGV0ZWRfYXQ6D7pHDJICCeaymeeuseexuyKDBQoLU2FuZGJveFNwZWMSLwoCaWQYASABKAlCI7pHIDoPEg0ic3BlYy1hYmMxMjMikgIM6LWE5rqQ57yW5Y+3EjIKBG5hbWUYAiABKAlCJLpHIToQEg4i5qCH5YeG6KeE5qC8IpICDOinhOagvOWQjeensBJCCgtkZXNjcmlwdGlvbhgDIAEoCUItukcqOhkSFyIyIOaguCA0RyDmoIflh4bop4TmoLwikgIM6KeE5qC85o+P6L+wElsKCXRlbmFudF9pZBgEIAEoCUI9ukc6OhESDyJ0ZW5hbnQtYWJjMTIzIpICJOenn+aItyBJRO+8jOS4uuepuuihqOekuuWFrOWFsemFjee9rlIJdGVuYW50X2lkEmwKC3NwZWNfY29uZmlnGAUgASgLMjYuaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuU2FuZGJveFNwZWNDb25maWdCErpHD5ICDOinhOagvOmFjee9rlILc3BlY19jb25maWcSMAoEdGFncxgGIAMoCUIiukcfOg4SDFsic3RhbmRhcmQiXZICDOinhOagvOagh+etvhJcCgpjcmVhdGVkX2F0GAsgASgDQjy6Rzk6DBIKMTcwMDAwMDAwMJICIOWIm+W7uuaXtumXtO+8iFVuaXgg5pe26Ze05oiz77yJmgIFaW50NjRSCmNyZWF0ZWRfYXQSXAoKdXBkYXRlZF9hdBgMIAEoA0I8ukc5OgwSCjE3MDAwMDAwMDCSAiDmm7TmlrDml7bpl7TvvIhVbml4IOaXtumXtOaIs++8iZoCBWludDY0Ugp1cGRhdGVkX2F0OhK6Rw+SAgzmspnnrrHop4TmoLwi2AcKEVNhbmRib3hTcGVjQ29uZmlnEmEKD2NwdV9taWxsaV9jb3JlcxgBIAEoBUI3ukc0OgYSBDIwMDCSAilDUFUg5qC45pWw77yIMSBjb3JlID0gMTAwMCBtaWxsaSBjb3Jlc++8iVIPY3B1X21pbGxpX2NvcmVzEkAKCW1lbW9yeV9tYhgCIAEoBUIiukcfOgYSBDQwOTaSAhTlhoXlrZjlpKflsI/vvIhNQu+8iVIJbWVtb3J5X21iEj0KB2Rpc2tfbWIYAyABKAVCI7pHIDoHEgUxMDI0MJICFOWtmOWCqOepuumXtO+8iE1C77yJUgdkaXNrX21iEmAKD3J1bl90aW1lb3V0X3NlYxgEIAEoBUI2ukczOgUSAzMwMJICKei/kOihjOi2heaXtu+8iOenku+8ie+8jDAg6KGo56S65LiN6ZmQ5Yi2Ug9ydW5fdGltZW91dF9zZWMSZAoOZXhwaXJlX3NlY29uZHMYBSABKAVCPLpHOToFEgM2MDCSAi/nqbrpl7Llm57mlLbml7bpl7TvvIjnp5LvvInvvIwwIOihqOekuuS4jeWbnuaUtlIOZXhwaXJlX3NlY29uZHMSSQoMYmlsbGluZ19tb2RlGAYgASgJQiW6RyI6ERIPInBheV9hc195b3VfZ28ikgIM6K6h6LS55qih5byPUgxiaWxsaW5nX21vZGUSTgoNc2FuZGJveF9jbGFzcxgHIAEoCUIoukclOgsSCSJkZWZhdWx0IpICFXNhbmRib3ggbWFuYWdlciBjbGFzc1INc2FuZGJveF9jbGFzcxKGAQoMc2FuZGJveF90eXBlGAggASgOMjAuaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuU2FuZGJveFR5cGVCMLpHLToKEggiRE9DS0VSIpICHuaymeeuseexu+Wei++8iHNhbmRib3ggdHlwZe+8iVIMc2FuZGJveF90eXBlEmkKCWJvb3RfdHlwZRgJIAEoDjItLmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLkJvb3RUeXBlQhy6Rxk6CBIGIklOSVQikgIM5ZCv5Yqo57G75Z6LUglib290X3R5cGUSbgoObmV0d29ya19wb2xpY3kYCiABKAsyMi5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5OZXR3b3JrUG9saWN5QhK6Rw+SAgznvZHnu5znrZbnlaVSDm5ldHdvcmtfcG9saWN5Ohi6RxWSAhLmspnnrrHop4TmoLzphY3nva4itAIKDU5ldHdvcmtQb2xpY3kSWwoJYmFuZHdpZHRoGAEgASgLMjQuaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuQmFuZHdpZHRoUG9saWN5QhK6Rw+SAgzluKblrr3pmZDliLYSWwoGZWdyZXNzGAIgASgLMjEuaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuRWdyZXNzUG9saWN5Qhi6RxWSAhLlh7rnq5norr/pl67mjqfliLYSVQoDZG5zGAMgASgLMi4uaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuRG5zUG9saWN5Qhi6RxWSAhLln5/lkI3orr/pl67mjqfliLY6ErpHD5ICDOe9kee7nOetlueVpSJ3Cg9CYW5kd2lkdGhQb2xpY3kSUAoEa2JwcxgBIAEoDUJCukc/OgYSBDEwMjSSAjTlj4zlkJHluKblrr3pmZDpgJ/vvIzljZXkvY0ga2Jwc++8jDAg6KGo56S65LiN6ZmQ6YCfOhK6Rw+SAgzluKblrr3nrZbnlaUi+gEKDEVncmVzc1BvbGljeRJeCg1kZW55X2ludHJhbmV0GAEgASgIQji6RzU6BhIEdHJ1ZZICKuS4uiB0cnVlIOaXtuemgeatouiuv+mXriBSRkMxOTE4IOWGhee9keautVINZGVueV9pbnRyYW5ldBJqCgthbGxvd19jaWRycxgCIAMoCUJIukdFOhASDlsiMTAuMC4wLjAvOCJdkgIwZGVueUludHJhbmV0PXRydWUg5pe255qE5L6L5aSW5pS+6KGMIENJRFIg5YiX6KGoUgthbGxvd19jaWRyczoeukcbkgIY5Ye656uZ6K6/6Zeu5o6n5Yi2562W55WlIu0BCglEbnNQb2xpY3kSXAoJYWxsb3dsaXN0GAEgAygJQkm6R0Y6ERIPWyJleGFtcGxlLmNvbSJdkgIw5YWB6K646Kej5p6Q55qE5Z+f5ZCN5YiX6KGo77yM56m65YiZ5pS+6KGM5omA5pyJEmIKCGRlbnlsaXN0GAIgAygJQlC6R006ERIPWyJibG9ja2VkLmNvbSJdkgI356aB5q2i6Kej5p6Q55qE5Z+f5ZCN5YiX6KGo77yM5LyY5YWI57qn6auY5LqOIGFsbG93bGlzdDoeukcbkgIY5Z+f5ZCN6K6/6Zeu5o6n5Yi2562W55WlIssFChJTYW5kYm94RW52aXJvbm1lbnQSLgoCaWQYASABKAlCIrpHHzoOEgwiZW52LWFiYzEyMyKSAgzotYTmupDnvJblj7cSMwoEbmFtZRgCIAEoCUIlukciOhESDyJQeXRob24g546v5aKDIpICDOeOr+Wig+WQjeensBJFCgtkZXNjcmlwdGlvbhgDIAEoCUIwukctOhwSGiJQeXRob24gMy4xMSDov5DooYznjq/looMikgIM546v5aKD5o+P6L+wElsKCXRlbmFudF9pZBgEIAEoCUI9ukc6OhESDyJ0ZW5hbnQtYWJjMTIzIpICJOenn+aItyBJRO+8jOS4uuepuuihqOekuuWFrOWFsemFjee9rlIJdGVuYW50X2lkEoEBChJlbnZpcm9ubWVudF9jb25maWcYBSABKAsyPS5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5TYW5kYm94RW52aXJvbm1lbnRDb25maWdCErpHD5ICDOeOr+Wig+mFjee9rlISZW52aXJvbm1lbnRfY29uZmlnEi4KBHRhZ3MYBiADKAlCILpHHToMEgpbInB5dGhvbiJdkgIM546v5aKD5qCH562+ElwKCmNyZWF0ZWRfYXQYCyABKANCPLpHOToMEgoxNzAwMDAwMDAwkgIg5Yib5bu65pe26Ze077yIVW5peCDml7bpl7TmiLPvvImaAgVpbnQ2NFIKY3JlYXRlZF9hdBJcCgp1cGRhdGVkX2F0GAwgASgDQjy6Rzk6DBIKMTcwMDAwMDAwMJICIOabtOaWsOaXtumXtO+8iFVuaXgg5pe26Ze05oiz77yJmgIFaW50NjRSCnVwZGF0ZWRfYXQ6PLpHOZICNuaymeeuseeOr+Wig++8iOmVnOWDjyArIOeOr+Wig+WPmOmHjyArIOWQr+WKqOWPguaVsO+8iSKPBQoYU2FuZGJveEVudmlyb25tZW50Q29uZmlnEjIKBWltYWdlGAEgASgJQiO6RyA6DxINInB5dGhvbjozLjExIpICDOmVnOWDj+WcsOWdgBI9CghlbnZfdmFycxgCIAEoCUIhukceOg0SCyJLRVk9dmFsdWUikgIM546v5aKD5Y+Y6YePUghlbnZfdmFycxJJCg5zdGFydHVwX3BhcmFtcxgDIAEoCUIhukceOg0SCyItLXZlcmJvc2UikgIM5ZCv5Yqo5Y+C5pWwUg5zdGFydHVwX3BhcmFtcxJUChBpbnRlcm5hbF93b3JrZGlyGAQgASgJQii6RyU6DhIMIi93b3Jrc3BhY2UikgIS5YaF6YOo5bel5L2c55uu5b2VUhBpbnRlcm5hbF93b3JrZGlyElkKEGV4dGVybmFsX3dvcmtkaXIYBSABKAlCLbpHKjoTEhEiL2RhdGEvd29ya3NwYWNlIpICEuWklumDqOW3peS9nOebruW9lVIQZXh0ZXJuYWxfd29ya2RpchI6Cglib290X3R5cGUYBiABKAlCHLpHGToIEgYiSU5JVCKSAgzlkK/liqjnsbvlnotSCWJvb3RfdHlwZRJiCg1pbml0X2NvbW1hbmRzGAcgAygJQjy6Rzk6JRIjWyJwaXAgaW5zdGFsbCAtciByZXF1aXJlbWVudHMudHh0Il2SAg/liJ3lp4vljJblkb3ku6RSDWluaXRfY29tbWFuZHMSSgoSc2FuZGJveF9kZWZpbml0aW9uGAggASgJQhq6Rxc6BhIEInt9IpICDOaymeeuseWumuS5iVISc2FuZGJveF9kZWZpbml0aW9uOhi6RxWSAhLmspnnrrHnjq/looPphY3nva4ioAIKElRlbmFudFNhbmRib3hTcGVjcxIuCgJpZBgBIAEoCUIiukcfOg4SDCJ0c3MtYWJjMTIzIpICDOi1hOa6kOe8luWPtxJACgdzcGVjX2lkGAIgASgJQia6RyM6DxINInNwZWMtYWJjMTIzIpICD+aymeeuseinhOagvCBJRFIHc3BlY19pZBJACgl0ZW5hbnRfaWQYAyABKAlCIrpHHzoREg8idGVuYW50LWFiYzEyMyKSAgnnp5/miLcgSURSCXRlbmFudF9pZBI2Cghpc192YWxpZBgEIAEoCEIaukcXOgYSBHRydWWSAgzmmK/lkKbmnInmlYhSCGlzX3ZhbGlkOh66RxuSAhjnp5/miLfmspnnrrHop4TmoLzlhbPogZQqVwoOTW91bnRQb2ludFR5cGUSIAocTU9VTlRfUE9JTlRfVFlQRV9VTlNQRUNJRklFRBAAEiMKH01PVU5UX1BPSU5UX1RZUEVfT0JKRUNUX1NUT1JBR0UQASohCgtTYW5kYm94VHlwZRIKCgZET0NLRVIQABIGCgJWTRABKiEKCEJvb3RUeXBlEggKBElOSVQQABILCgdQUkVIRUFUEAFCSVpHZ2l0bGFiLmluZmluaS1haS5jb20vbWl6YXIvaW5maW5pYWktYWdlbnRpYy1pbmZyYS9jb21tb24vZ3JwY2FwaXMvdjE7djFiBnByb3RvMw", [file_agentplatform_v1_param, file_gnostic_openapi_v3_annotations]);

/**
 * 定义沙箱
 *
 * @generated from message infinigence.infini.agentplatform.v1.Sandbox
 */
export type Sandbox = Message<"infinigence.infini.agentplatform.v1.Sandbox"> & {
  /**
   * 资源编号
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 沙箱名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 沙箱描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 6 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 所属的沙箱类 ID
   * @gotags: json:"class_id,omitempty"
   *
   * @generated from field: string class_id = 7 [json_name = "class_id"];
   */
  classId: string;

  /**
   * 使用沙箱类创建沙箱时传入的参数列表
   * @gotags: json:"class_params,omitempty"
   *
   * @generated from field: map<string, string> class_params = 8 [json_name = "class_params"];
   */
  classParams: { [key: string]: string };

  /**
   * 沙箱类型
   * @gotags: json:"type,omitempty"
   *
   * @generated from field: string type = 10;
   */
  type: string;

  /**
   * 沙箱服务提供者
   * @gotags: json:"provider,omitempty"
   *
   * @generated from field: string provider = 11;
   */
  provider: string;

  /**
   * 沙箱规格 ID
   * @gotags: json:"sandbox_spec_id,omitempty"
   *
   * @generated from field: string sandbox_spec_id = 12 [json_name = "sandbox_spec_id"];
   */
  sandboxSpecId: string;

  /**
   * 沙箱环境 ID
   * @gotags: json:"sandbox_environment_id,omitempty"
   *
   * @generated from field: string sandbox_environment_id = 13 [json_name = "sandbox_environment_id"];
   */
  sandboxEnvironmentId: string;

  /**
   * 沙箱环境变量
   * @gotags: json:"env,omitempty"
   *
   * @generated from field: map<string, string> env = 14;
   */
  env: { [key: string]: string };

  /**
   * 沙箱工具调用是否需要审批
   * true: 所有工具调用需审批确认（RequireConfirmation: true）
   * false/unset: 所有调用免审批（向后兼容）
   * @gotags: json:"require_tool_approval,omitempty"
   *
   * @generated from field: bool require_tool_approval = 19 [json_name = "require_tool_approval"];
   */
  requireToolApproval: boolean;

  /**
   * 挂载点列表（如对象存储桶挂载到沙箱路径）
   * @gotags: json:"mount_points,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.MountPoint mount_points = 20 [json_name = "mount_points"];
   */
  mountPoints: MountPoint[];

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 16 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 17 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 18 [json_name = "deleted_at"];
   */
  deletedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.Sandbox.
 * Use `create(SandboxSchema)` to create a new message.
 */
export const SandboxSchema: GenMessage<Sandbox> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_sandbox, 0);

/**
 * MountPoint 描述把某个 Secret 指向的存储挂载到沙箱内的一个路径
 *
 * @generated from message infinigence.infini.agentplatform.v1.MountPoint
 */
export type MountPoint = Message<"infinigence.infini.agentplatform.v1.MountPoint"> & {
  /**
   * 挂载点 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 挂载类型
   * @gotags: json:"type,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MountPointType type = 2;
   */
  type: MountPointType;

  /**
   * 引用的 Secret ID（提供挂载所需凭证）
   * @gotags: json:"secret_id,omitempty"
   *
   * @generated from field: string secret_id = 3 [json_name = "secret_id"];
   */
  secretId: string;

  /**
   * 存储源，在对象存储中对应 Bucket
   * @gotags: json:"source,omitempty"
   *
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * 源下的子目录
   * @gotags: json:"sub_dir,omitempty"
   *
   * @generated from field: string sub_dir = 5 [json_name = "sub_dir"];
   */
  subDir: string;

  /**
   * 挂载到沙箱内的路径
   * @gotags: json:"mount_path,omitempty"
   *
   * @generated from field: string mount_path = 6 [json_name = "mount_path"];
   */
  mountPath: string;

  /**
   * 是否只读
   * @gotags: json:"read_only,omitempty"
   *
   * @generated from field: bool read_only = 7 [json_name = "read_only"];
   */
  readOnly: boolean;

  /**
   * 可扩展的挂载参数
   * @gotags: json:"options,omitempty"
   *
   * @generated from field: map<string, string> options = 8;
   */
  options: { [key: string]: string };

  /**
   * 备注
   * @gotags: json:"note,omitempty"
   *
   * @generated from field: string note = 9;
   */
  note: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.MountPoint.
 * Use `create(MountPointSchema)` to create a new message.
 */
export const MountPointSchema: GenMessage<MountPoint> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_sandbox, 1);

/**
 * @generated from message infinigence.infini.agentplatform.v1.SandboxTool
 */
export type SandboxTool = Message<"infinigence.infini.agentplatform.v1.SandboxTool"> & {
  /**
   * 工具名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 工具描述
   * @gotags: json:"description,omitempty"
   *
   * TODO
   *
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.SandboxTool.
 * Use `create(SandboxToolSchema)` to create a new message.
 */
export const SandboxToolSchema: GenMessage<SandboxTool> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_sandbox, 2);

/**
 * 定义沙箱类
 *
 * @generated from message infinigence.infini.agentplatform.v1.SandboxClass
 */
export type SandboxClass = Message<"infinigence.infini.agentplatform.v1.SandboxClass"> & {
  /**
   * 资源编号
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 沙箱类名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 沙箱类描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 6 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 沙箱 Template
   * @gotags: json:"template,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Sandbox template = 10;
   */
  template?: Sandbox | undefined;

  /**
   * 沙箱类参数
   * @gotags: json:"params,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Param params = 11;
   */
  params: Param[];

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 12 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 13 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 14 [json_name = "deleted_at"];
   */
  deletedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.SandboxClass.
 * Use `create(SandboxClassSchema)` to create a new message.
 */
export const SandboxClassSchema: GenMessage<SandboxClass> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_sandbox, 3);

/**
 * 沙箱规格配置
 *
 * @generated from message infinigence.infini.agentplatform.v1.SandboxSpec
 */
export type SandboxSpec = Message<"infinigence.infini.agentplatform.v1.SandboxSpec"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * 租户 ID，为空表示公共配置
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 4 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 规格配置
   * @gotags: json:"spec_config,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SandboxSpecConfig spec_config = 5 [json_name = "spec_config"];
   */
  specConfig?: SandboxSpecConfig | undefined;

  /**
   * 规格标签
   * @gotags: json:"tags,omitempty"
   *
   * @generated from field: repeated string tags = 6;
   */
  tags: string[];

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 11 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 12 [json_name = "updated_at"];
   */
  updatedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.SandboxSpec.
 * Use `create(SandboxSpecSchema)` to create a new message.
 */
export const SandboxSpecSchema: GenMessage<SandboxSpec> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_sandbox, 4);

/**
 * @generated from message infinigence.infini.agentplatform.v1.SandboxSpecConfig
 */
export type SandboxSpecConfig = Message<"infinigence.infini.agentplatform.v1.SandboxSpecConfig"> & {
  /**
   * CPU 核数（1 core = 1000 milli cores）
   * @gotags: json:"cpu_milli_cores,omitempty"
   *
   * @generated from field: int32 cpu_milli_cores = 1 [json_name = "cpu_milli_cores"];
   */
  cpuMilliCores: number;

  /**
   * 内存大小（MB）
   * @gotags: json:"memory_mb,omitempty"
   *
   * @generated from field: int32 memory_mb = 2 [json_name = "memory_mb"];
   */
  memoryMb: number;

  /**
   * 存储空间（MB）
   * @gotags: json:"disk_mb,omitempty"
   *
   * @generated from field: int32 disk_mb = 3 [json_name = "disk_mb"];
   */
  diskMb: number;

  /**
   * 运行超时（秒），0 表示不限制
   * @gotags: json:"run_timeout_sec,omitempty"
   *
   * @generated from field: int32 run_timeout_sec = 4 [json_name = "run_timeout_sec"];
   */
  runTimeoutSec: number;

  /**
   * 空闲回收时间（秒），0 表示不回收
   * @gotags: json:"expire_seconds,omitempty"
   *
   * @generated from field: int32 expire_seconds = 5 [json_name = "expire_seconds"];
   */
  expireSeconds: number;

  /**
   * 计费模式
   * @gotags: json:"billing_mode,omitempty"
   *
   * @generated from field: string billing_mode = 6 [json_name = "billing_mode"];
   */
  billingMode: string;

  /**
   * sandbox manager class
   * @gotags: json:"sandbox_class,omitempty"
   *
   * @generated from field: string sandbox_class = 7 [json_name = "sandbox_class"];
   */
  sandboxClass: string;

  /**
   * sandbox type
   * @gotags: json:"sandbox_type,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SandboxType sandbox_type = 8 [json_name = "sandbox_type"];
   */
  sandboxType: SandboxType;

  /**
   * 启动类型
   * @gotags: json:"boot_type,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.BootType boot_type = 9 [json_name = "boot_type"];
   */
  bootType: BootType;

  /**
   * 网络策略
   * @gotags: json:"network_policy,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.NetworkPolicy network_policy = 10 [json_name = "network_policy"];
   */
  networkPolicy?: NetworkPolicy | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.SandboxSpecConfig.
 * Use `create(SandboxSpecConfigSchema)` to create a new message.
 */
export const SandboxSpecConfigSchema: GenMessage<SandboxSpecConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_sandbox, 5);

/**
 * @generated from message infinigence.infini.agentplatform.v1.NetworkPolicy
 */
export type NetworkPolicy = Message<"infinigence.infini.agentplatform.v1.NetworkPolicy"> & {
  /**
   * 带宽限制
   * @gotags: json:"bandwidth,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.BandwidthPolicy bandwidth = 1;
   */
  bandwidth?: BandwidthPolicy | undefined;

  /**
   * 出站访问控制
   * @gotags: json:"egress,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.EgressPolicy egress = 2;
   */
  egress?: EgressPolicy | undefined;

  /**
   * 域名访问控制
   * @gotags: json:"dns,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.DnsPolicy dns = 3;
   */
  dns?: DnsPolicy | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.NetworkPolicy.
 * Use `create(NetworkPolicySchema)` to create a new message.
 */
export const NetworkPolicySchema: GenMessage<NetworkPolicy> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_sandbox, 6);

/**
 * @generated from message infinigence.infini.agentplatform.v1.BandwidthPolicy
 */
export type BandwidthPolicy = Message<"infinigence.infini.agentplatform.v1.BandwidthPolicy"> & {
  /**
   * 双向带宽限速，单位 kbps，0 表示不限速
   * @gotags: json:"kbps,omitempty"
   *
   * @generated from field: uint32 kbps = 1;
   */
  kbps: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.BandwidthPolicy.
 * Use `create(BandwidthPolicySchema)` to create a new message.
 */
export const BandwidthPolicySchema: GenMessage<BandwidthPolicy> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_sandbox, 7);

/**
 * @generated from message infinigence.infini.agentplatform.v1.EgressPolicy
 */
export type EgressPolicy = Message<"infinigence.infini.agentplatform.v1.EgressPolicy"> & {
  /**
   * 为 true 时禁止访问 RFC1918 内网段
   * @gotags: json:"deny_intranet,omitempty"
   *
   * @generated from field: bool deny_intranet = 1 [json_name = "deny_intranet"];
   */
  denyIntranet: boolean;

  /**
   * denyIntranet=true 时的例外放行 CIDR 列表
   * @gotags: json:"allow_cidrs,omitempty"
   *
   * @generated from field: repeated string allow_cidrs = 2 [json_name = "allow_cidrs"];
   */
  allowCidrs: string[];
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.EgressPolicy.
 * Use `create(EgressPolicySchema)` to create a new message.
 */
export const EgressPolicySchema: GenMessage<EgressPolicy> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_sandbox, 8);

/**
 * @generated from message infinigence.infini.agentplatform.v1.DnsPolicy
 */
export type DnsPolicy = Message<"infinigence.infini.agentplatform.v1.DnsPolicy"> & {
  /**
   * 允许解析的域名列表，空则放行所有
   * @gotags: json:"allowlist,omitempty"
   *
   * @generated from field: repeated string allowlist = 1;
   */
  allowlist: string[];

  /**
   * 禁止解析的域名列表，优先级高于 allowlist
   * @gotags: json:"denylist,omitempty"
   *
   * @generated from field: repeated string denylist = 2;
   */
  denylist: string[];
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.DnsPolicy.
 * Use `create(DnsPolicySchema)` to create a new message.
 */
export const DnsPolicySchema: GenMessage<DnsPolicy> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_sandbox, 9);

/**
 * 沙箱环境配置（镜像 + 环境变量 + 启动参数）
 *
 * @generated from message infinigence.infini.agentplatform.v1.SandboxEnvironment
 */
export type SandboxEnvironment = Message<"infinigence.infini.agentplatform.v1.SandboxEnvironment"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * 租户 ID，为空表示公共配置
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 4 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 环境配置
   * @gotags: json:"environment_config,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SandboxEnvironmentConfig environment_config = 5 [json_name = "environment_config"];
   */
  environmentConfig?: SandboxEnvironmentConfig | undefined;

  /**
   * 环境标签
   * @gotags: json:"tags,omitempty"
   *
   * @generated from field: repeated string tags = 6;
   */
  tags: string[];

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 11 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 12 [json_name = "updated_at"];
   */
  updatedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.SandboxEnvironment.
 * Use `create(SandboxEnvironmentSchema)` to create a new message.
 */
export const SandboxEnvironmentSchema: GenMessage<SandboxEnvironment> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_sandbox, 10);

/**
 * @generated from message infinigence.infini.agentplatform.v1.SandboxEnvironmentConfig
 */
export type SandboxEnvironmentConfig = Message<"infinigence.infini.agentplatform.v1.SandboxEnvironmentConfig"> & {
  /**
   * 镜像地址
   * @gotags: json:"image,omitempty"
   *
   * @generated from field: string image = 1;
   */
  image: string;

  /**
   * 环境变量
   * @gotags: json:"env_vars,omitempty"
   *
   * @generated from field: string env_vars = 2 [json_name = "env_vars"];
   */
  envVars: string;

  /**
   * 启动参数
   * @gotags: json:"startup_params,omitempty"
   *
   * @generated from field: string startup_params = 3 [json_name = "startup_params"];
   */
  startupParams: string;

  /**
   * 内部工作目录
   * @gotags: json:"internal_workdir,omitempty"
   *
   * @generated from field: string internal_workdir = 4 [json_name = "internal_workdir"];
   */
  internalWorkdir: string;

  /**
   * 外部工作目录
   * @gotags: json:"external_workdir,omitempty"
   *
   * @generated from field: string external_workdir = 5 [json_name = "external_workdir"];
   */
  externalWorkdir: string;

  /**
   * 启动类型
   * @gotags: json:"boot_type,omitempty"
   *
   * @generated from field: string boot_type = 6 [json_name = "boot_type"];
   */
  bootType: string;

  /**
   * 初始化命令
   * @gotags: json:"init_commands,omitempty"
   *
   * @generated from field: repeated string init_commands = 7 [json_name = "init_commands"];
   */
  initCommands: string[];

  /**
   * 沙箱定义
   * @gotags: json:"sandbox_definition,omitempty"
   *
   * @generated from field: string sandbox_definition = 8 [json_name = "sandbox_definition"];
   */
  sandboxDefinition: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.SandboxEnvironmentConfig.
 * Use `create(SandboxEnvironmentConfigSchema)` to create a new message.
 */
export const SandboxEnvironmentConfigSchema: GenMessage<SandboxEnvironmentConfig> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_sandbox, 11);

/**
 * @generated from message infinigence.infini.agentplatform.v1.TenantSandboxSpecs
 */
export type TenantSandboxSpecs = Message<"infinigence.infini.agentplatform.v1.TenantSandboxSpecs"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 沙箱规格 ID
   * @gotags: json:"spec_id"
   *
   * @generated from field: string spec_id = 2 [json_name = "spec_id"];
   */
  specId: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 3 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 是否有效
   * @gotags: json:"is_valid,omitempty"
   *
   * @generated from field: bool is_valid = 4 [json_name = "is_valid"];
   */
  isValid: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.TenantSandboxSpecs.
 * Use `create(TenantSandboxSpecsSchema)` to create a new message.
 */
export const TenantSandboxSpecsSchema: GenMessage<TenantSandboxSpecs> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_sandbox, 12);

/**
 * MountPointType 挂载点类型
 *
 * @generated from enum infinigence.infini.agentplatform.v1.MountPointType
 */
export enum MountPointType {
  /**
   * 未指定
   *
   * @generated from enum value: MOUNT_POINT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 对象存储挂载
   *
   * @generated from enum value: MOUNT_POINT_TYPE_OBJECT_STORAGE = 1;
   */
  OBJECT_STORAGE = 1,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.MountPointType.
 */
export const MountPointTypeSchema: GenEnum<MountPointType> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_sandbox, 0);

/**
 * @generated from enum infinigence.infini.agentplatform.v1.SandboxType
 */
export enum SandboxType {
  /**
   * docker 沙箱
   *
   * @generated from enum value: DOCKER = 0;
   */
  DOCKER = 0,

  /**
   * vm 沙箱
   *
   * @generated from enum value: VM = 1;
   */
  VM = 1,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.SandboxType.
 */
export const SandboxTypeSchema: GenEnum<SandboxType> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_sandbox, 1);

/**
 * @generated from enum infinigence.infini.agentplatform.v1.BootType
 */
export enum BootType {
  /**
   * 冷启动
   *
   * @generated from enum value: INIT = 0;
   */
  INIT = 0,

  /**
   * 预热启动
   *
   * @generated from enum value: PREHEAT = 1;
   */
  PREHEAT = 1,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.BootType.
 */
export const BootTypeSchema: GenEnum<BootType> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_sandbox, 2);

